<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper is-balance">
      <!-- header start -->
      <header class="header">
        <!-- <a href="#" class="back-btn">
          <img src="@/assets/img/left-arrow.svg" alt="back" class="icon" />
          <span>Back</span>
        </a> -->
        <div class="page-title">Browse ALL</div>
      </header>
      <!-- header end -->

      <!-- main content wrapper start-->
      <main class="content-wrapper">
        <!-- all product-->
        <section>
          <div class="has-text-centered">
            <img src="@/assets/img/logo.png" alt="logo" />
          </div>
          <div class="product-list">
            <div class="columns is-mobile is-multiline">
              <div
                class="column is-6"
                v-for="product in allProducts"
                :key="product.id"
              >
                <a @click="$router.push(`/product/${product.id}`)">
                  <div class="product-block is-balance">
                    <div class="product-img">
                      <img
                        :src="product.image"
                        width="83"
                        alt="product"
                        style="height: 90px !important;"
                      />
                    </div>
                    <h3>{{ product.name }}</h3>
                    <p>{{ product.description }}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <!-- main content wrapper end-->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "products",

  computed: {
    ...mapGetters({
      allProducts: "Products/allProducts"
    })
  },

  methods: {
    ...mapActions({
      fetchAllProducts: "Products/fetchAllProducts"
    })
  },

  mounted() {
    this.fetchAllProducts();
  }
};
</script>

<style scoped>
.product-block.is-balance .product-img {
  background-image: none;
}

.product-block p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
